import api from "./api";

function isAbonada() {
  return localStorage.getItem("mensalidade_abonada") === "S";
}

/**
 * Consulta o plano da entidade e bloqueia novo documento se o limite de ativos foi atingido.
 * @returns {Promise<boolean>} true se pode adicionar; false se bloqueado (toast exibido).
 */
export async function podeAdicionarDocumentoAtivo({ baseUrl, token, entidadeID, toast }) {
  if (isAbonada()) return true;
  if (!entidadeID || !token) return true;

  try {
    const { data } = await api.get(`${baseUrl}/api/assinaturas/resumo`, {
      headers: {
        Authorization: `Bearer ${token}`,
        id_entidade: entidadeID,
      },
    });
    const uso = data?.data?.uso;
    const limites = data?.data?.limites || [];
    const limiteDoc = limites.find((l) => l.codigo === "DOCUMENTOS_ATIVOS");
    const ativos = Number(uso?.documentosAtivos) || 0;
    const max =
      limiteDoc?.ilimitado || limiteDoc?.valor_numerico == null
        ? null
        : Number(limiteDoc.valor_numerico);

    if (max != null && ativos >= max) {
      if (toast?.warning) {
        toast.warning(
          `Você Excedeu o número máximo de Documentos. Quantidade de Documentos ativos do plano : ${max.toLocaleString("pt-BR")}. Faça upgrade do plano para cadastrar novos Documentos.`
        );
      }
      return false;
    }
    return true;
  } catch {
    return true;
  }
}

/**
 * Consulta o plano da entidade e bloqueia nova filial (classificação V) se o limite foi atingido.
 * @returns {Promise<boolean>} true se pode adicionar; false se bloqueado (toast exibido).
 */
export async function podeAdicionarFilial({ baseUrl, token, entidadeID, toast }) {
  if (isAbonada()) return true;
  if (!entidadeID || !token) return true;

  try {
    const { data } = await api.get(`${baseUrl}/api/assinaturas/resumo`, {
      headers: {
        Authorization: `Bearer ${token}`,
        id_entidade: entidadeID,
      },
    });
    const uso = data?.data?.uso;
    const limites = data?.data?.limites || [];
    const limiteFilial = limites.find((l) => l.codigo === "FILIAIS");
    const filiais = Number(uso?.filiais) || 0;
    const max =
      limiteFilial?.ilimitado || limiteFilial?.valor_numerico == null
        ? null
        : Number(limiteFilial.valor_numerico);

    if (max != null && filiais >= max) {
      if (toast?.warning) {
        toast.warning(
          `Você excedeu o número máximo de filiais do plano: ${max.toLocaleString("pt-BR")}. Faça upgrade do plano para cadastrar novas filiais.`
        );
      }
      return false;
    }
    return true;
  } catch {
    return true;
  }
}

/**
 * Consulta o plano da entidade e bloqueia novo fornecedor (classificaÃ§Ã£o F) se o limite foi atingido.
 * @returns {Promise<boolean>} true se pode adicionar; false se bloqueado (toast exibido).
 */
export async function podeAdicionarFornecedor({ baseUrl, token, entidadeID, toast }) {
  if (isAbonada()) return true;
  if (!entidadeID || !token) return true;

  try {
    const { data } = await api.get(`${baseUrl}/api/assinaturas/resumo`, {
      headers: {
        Authorization: `Bearer ${token}`,
        id_entidade: entidadeID,
      },
    });
    const uso = data?.data?.uso;
    const limites = data?.data?.limites || [];
    const limiteFornecedor = limites.find((l) => l.codigo === "FORNECEDORES");
    const fornecedores = Number(uso?.fornecedores) || 0;
    const max =
      limiteFornecedor?.ilimitado || limiteFornecedor?.valor_numerico == null
        ? null
        : Number(limiteFornecedor.valor_numerico);

    if (max != null && fornecedores >= max) {
      if (toast?.warning) {
        toast.warning(
          `VocÃª excedeu o nÃºmero mÃ¡ximo de fornecedores do plano: ${max.toLocaleString("pt-BR")}. FaÃ§a upgrade do plano para cadastrar novos fornecedores.`
        );
      }
      return false;
    }
    return true;
  } catch {
    return true;
  }
}

/**
 * Consulta o plano da entidade e bloqueia novo usuário operacional se o limite foi atingido.
 * Usuários tipo Comunicado (C) não entram neste limite — a checagem no + Adicionar assume cadastro operacional.
 * @returns {Promise<boolean>} true se pode adicionar; false se bloqueado (toast exibido).
 */
export async function podeAdicionarUsuarioOperacional({ baseUrl, token, entidadeID, toast }) {
  if (isAbonada()) return true;
  if (!entidadeID || !token) return true;

  try {
    const { data } = await api.get(`${baseUrl}/api/assinaturas/resumo`, {
      headers: {
        Authorization: `Bearer ${token}`,
        id_entidade: entidadeID,
      },
    });
    const uso = data?.data?.uso;
    const limites = data?.data?.limites || [];
    const limiteUsuarios = limites.find((l) => l.codigo === "USUARIOS_OPERACIONAIS");
    const usuarios = Number(uso?.usuariosOperacionais) || 0;
    const max =
      limiteUsuarios?.ilimitado || limiteUsuarios?.valor_numerico == null
        ? null
        : Number(limiteUsuarios.valor_numerico);

    if (max != null && usuarios >= max) {
      if (toast?.warning) {
        toast.warning(
          `Você Excedeu o número máximo de Usuários. Quantidade de usuários ativos do plano : ${max.toLocaleString("pt-BR")}. Faça upgrade do plano para cadastrar novos usuários.`
        );
      }
      return false;
    }
    return true;
  } catch {
    return true;
  }
}
